import api from './api';

/**
 * Analyze domain match between resume and job
 * Uses Haiku for fast, cheap analysis before tailoring
 */
export const analyzeDomainMatch = async (resumeId, jobId) => {
  const response = await api.post('/generate/analyze-match', { resumeId, jobId });
  return response.data;
};

/**
 * Generate tailored resume for a job
 * @param {string} resumeId - Resume ID
 * @param {string} jobId - Job ID
 * @param {Object} options - Optional parameters
 * @param {string} options.tailoringMode - 'standard' or 'career_pivot'
 * @param {Object} options.domainAnalysisData - Pre-computed domain analysis
 */
export const tailorResume = async (resumeId, jobId, options = {}) => {
  const { tailoringMode = 'standard', domainAnalysisData = null } = options;
  const response = await api.post('/generate/tailor', {
    resumeId,
    jobId,
    tailoringMode,
    domainAnalysisData
  });
  return response.data;
};

/**
 * Generate cover letter for a job
 */
export const generateCoverLetter = async (jobId, resumeId = null, tone = 'professional') => {
  const response = await api.post('/generate/cover-letter', { jobId, resumeId, tone });
  return response.data;
};

/**
 * Get tailored resume by ID
 */
export const getTailoredResume = async (id) => {
  const response = await api.get(`/generate/tailored/${id}`);
  return response.data;
};

/**
 * Get tailored resume for a specific job
 */
export const getTailoredResumeByJob = async (jobId) => {
  const response = await api.get(`/generate/tailored/job/${jobId}`);
  return response.data;
};

/**
 * Update cover letter
 */
export const updateCoverLetter = async (tailoredId, coverLetter) => {
  const response = await api.put(`/generate/tailored/${tailoredId}/cover-letter`, { coverLetter });
  return response.data;
};

/**
 * List all tailored resumes
 */
export const listTailoredResumes = async () => {
  const response = await api.get('/generate/tailored');
  return response.data;
};

/**
 * Generate interview prep questions and talking points
 */
export const generateInterviewPrep = async (jobId, resumeId = null) => {
  const response = await api.post('/generate/interview-prep', { jobId, resumeId });
  return response.data;
};

export default {
  analyzeDomainMatch,
  tailorResume,
  generateCoverLetter,
  getTailoredResume,
  getTailoredResumeByJob,
  updateCoverLetter,
  listTailoredResumes,
  generateInterviewPrep
};
